/* Links out of the dashboard and into the public marketing site.
 *
 * The help centre lives on the public site so the articles are indexable and
 * readable without an account. The dashboard links to those same pages rather
 * than keeping a second, private copy of the documentation.
 *
 * In development the default points at the landing dev server (vite serves it
 * on 5173), so `npm run dev` in landing/ makes the in-app Help link work before
 * anything is deployed. Set REACT_APP_MARKETING_URL to override either default,
 * for example when the dashboard staging build should reach a staging site.
 */
const DEFAULT_MARKETING_URL =
  process.env.NODE_ENV === "production" ? "https://complaudax.com" : "http://localhost:5173";

export const MARKETING_URL = (process.env.REACT_APP_MARKETING_URL || DEFAULT_MARKETING_URL).replace(/\/$/, "");

export const marketingUrl = (path = "/") => `${MARKETING_URL}${path}`;
